import React from 'react';
import Chatboat from '../../../../assets/chatbot.png';
import { BiChevronRight } from 'react-icons/bi';
import brandlogo from '../../../../assets/chatbotBlueTheme.png';
import DummyBanner from '../../../../assets/DummyBanner.png';
import Email from '../../../../assets/email.png';
import Whatsaap from '../../../../assets/whats_app.png';

const ChatPreview = (props: any) => {
  const actionList = [
    {
      label: 'Check-In',
      description:
        'Easily check into your reserved hotel room or explore your existing bookings for a smooth experience.'
    },
    {
      label: 'Booking',
      description: 'Make a reservation or check your existing bookings.'
    },
    {
      label: 'Services',
      description: 'Explore the range of services we offer to enhance your experience.'
    },
    {
      label: 'Enquiry',
      description: 'Have a question? Reach out to learn more about our offerings.'
    },
    {
      label: 'Feedback',
      description: 'We value your input! Share your experience to help us improve.'
    },
    {
      label: 'Complaint',
      description: 'Report an issue or let us know your concerns for immediate assistance.'
    },
    {
      label: 'Chat With Agent',
      description: 'We are here to assist you! Share your feedback or ask any questions.'
    }
  ];

  const filteredActionList = actionList.filter((action) => props.menu.includes(action.label));

  return (
    <div
      className="fixed right-8 w-[19%] h-[calc(80vh-4rem)] shadow-xl transition-all duration-300 transform bg-white bottom-[70px] rounded-xl"
      style={{
        zIndex: 9999,
        background: `linear-gradient(to bottom,${props.selectedTheme} 15%, #FFFFFF 60%)`
      }}
    >
      <div className="flex flex-col h-full">
        <div className="text-white p-4 rounded-t-lg flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img src={Chatboat} alt="Chatbot" className="w-7 h-7" />
            <div className="flex items-center">
              <label className="text-sm font-semibold">Hi, customer👋</label>
            </div>
          </div>
        </div>

        <div className="flex flex-col px-4 text-white gap-2.5 pb-1">
          <label className="text-xl font-medium">How can we assist you today?</label>
          <div className="grid grid-cols-2 gap-2.5">
            <div className="p-2 flex flex-wrap items-center rounded-lg gap-2 justify-start bg-white cursor-pointer">
              <img src={Email} className="w-5 h-5" alt="Email" />
              <span className="text-sm font-medium text-black">Mail us</span>
            </div>
            <div className="p-2 flex flex-wrap items-center rounded-lg gap-2 justify-start bg-white cursor-pointer">
              <img src={Whatsaap} className="w-5 h-5" alt="WhatsApp" />
              <span className="text-sm font-medium text-black">WhatsApp</span>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <div className="space-y-4">
            <img src={DummyBanner} className="rounded-md" />
            <div className="flex gap-3 flex-col">
              {filteredActionList.map((info: any, index: number) => (
                <button
                  className="w-full p-1.5 text-left bg-white rounded-md transition-colors flex items-center justify-between group"
                  style={{
                    boxShadow: '0 4px 6px #00000040'
                  }}
                  key={index}
                >
                  <div>
                    <label className="text-sm text-black">{info.label}</label>
                    <p className="text-xs text-gray-600">{info.description}</p>
                  </div>
                  <div className="ml-2 flex-shrink-0">
                    <BiChevronRight
                      className="transition-colors"
                      color={props.selectedTheme}
                      size={25}
                    />
                  </div>
                </button>
              ))}
            </div>
            {/*<div className="flex justify-center items-center gap-1 text-black text-sm">
              <label>Powered by</label>
              <img src={brandlogo} style={{ height: '24px', width: '24px' }} alt="brand-logo" />
              <label>Lopaa AI</label>
            </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatPreview;
